const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/BigPicture/BigPicture.tsx';
import { css, cx } from '@emotion/css';
import { ImageClientLoader } from '../ImageClientLoader/ImageClientLoader';

/**
 * React props
 */
export interface IBigPictureProps {
    isVisible: boolean;
}

const pictureStyle = css`
    height: 100%;
`;

/**
 * Functional React component
 */
export const BigPicture = (props: IBigPictureProps) => {
    return <ImageClientLoader className={cx([props.isVisible && pictureStyle])} src={'BigPicture'} />;
};
